import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ThemeProvider } from "./context/ThemeContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import App from "./App";
import AboutMe from "./pages/AboutMe";
import ContactMe from "./pages/ContactMe";
import ErrorPage from "./pages/ErrorPage";
import {
  ANDDigital,
  Subwise,
  Codeweavers,
  VertuMotorsTechLead,
  VertuMotorsWebDev,
  AME,
} from "./pages/experiences";
import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <App />
        <Footer />
      </>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/about-me",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <AboutMe />
        <Footer />
      </>
    ),
  },
  {
    path: "/contact-me",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <ContactMe />
        <Footer />
      </>
    ),
  },
  {
    path: "/experience/and-digital",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <ANDDigital />
        <Footer />
      </>
    ),
  },
  {
    path: "/experience/subwise",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <Subwise />
        <Footer />
      </>
    ),
  },
  {
    path: "/experience/codeweavers",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <Codeweavers />
        <Footer />
      </>
    ),
  },
  {
    path: "/experience/vertu-motors-tech-lead",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <VertuMotorsTechLead />
        <Footer />
      </>
    ),
  },
  {
    path: "/experience/vertu-motors-web-dev",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <VertuMotorsWebDev />
        <Footer />
      </>
    ),
  },
  {
    path: "/experience/ame",
    element: (
      <>
        <ScrollToTop />
        <Header />
        <AME />
        <Footer />
      </>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>,
);
